export const mobileMaxWidth = 500;
const mobile =
  Math.min(window.innerHeight, window.innerWidth) <= mobileMaxWidth;
export function isMobile() {
  return mobile;
}
export const apiUrl = process.env.REACT_APP_API_URL;
export const apiTimeout = 20000;
